var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetSoft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.426,
    height: 17.883,
    viewBox: "0 0 16.426 17.883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_146",
    "data-name": "Union 146",
    d: "M2.99,2.723a.652.652,0,0,0,.232.931.85.85,0,0,0,.465.16.708.708,0,0,0,.445-.174A6.439,6.439,0,0,1,8.993,1.447a6.341,6.341,0,0,1,6.4,6.268,6.343,6.343,0,0,1-6.4,6.267,6.391,6.391,0,0,1-6.059-4.25l.994-.187a.43.43,0,0,0,.338-.31.394.394,0,0,0-.124-.42c-.092-.082-2.089-1.85-2.151-1.9a.453.453,0,0,0-.683.122L.048,9.59a.388.388,0,0,0,.044.439.4.4,0,0,0,.424.158l.956-.181a7.736,7.736,0,0,0,2.4,3.566,7.995,7.995,0,0,0,10.689-.405,7.6,7.6,0,0,0,0-10.908A7.985,7.985,0,0,0,2.99,2.723Z",
    transform: "translate(15.926 0.516) rotate(90)",
    fill: "#4a5577",
    stroke: "#4a5577",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetSoft);
export default __webpack_public_path__ + "static/media/reset_soft.874bb3ba174ca361d35f9cec5311eba4.svg";
export { ForwardRef as ReactComponent };